// extracted by mini-css-extract-plugin
module.exports = {"root":"SortArrows_root__pYzwt","empty":"SortArrows_empty__6n6fy"};